export const zipMimeType = 'application/zip, application/octet-stream, application/x-zip-compressed, multipart/x-zip';
